import { RootContextProviders } from './rootContextProvider';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

export const rootModule = createFrontendModule({
  pluginId: 'app',
  extensions: [RootContextProviders],
});
